// extracted by mini-css-extract-plugin
export default {"content":"EmptyMapList_content__XagZG","bold":"EmptyMapList_bold__5hbI7","buttonBlock":"EmptyMapList_buttonBlock__QDwUC"};